var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8972 26.5945L27.4197 26.0833C26.3444 25.9599 25.2867 26.3301 24.5287 27.0881L21.2851 30.3317C16.2964 27.7932 12.2066 23.7211 9.66821 18.7147L12.9294 15.4535C13.6874 14.6955 14.0576 13.6378 13.9342 12.5625L13.423 8.12019C13.2114 6.33974 11.7131 5 9.915 5H6.86534C4.87337 5 3.21633 6.65705 3.33973 8.64903C4.27402 23.7035 16.314 35.7259 31.3507 36.6602C33.3427 36.7836 34.9997 35.1265 34.9997 33.1346V30.0849C35.0174 28.3044 33.6776 26.806 31.8972 26.5945Z",
    fill: "#B0B3F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ec02f7fb.svg";
export { ForwardRef as ReactComponent };